import { faUserLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormWrapper from 'components/FormWrapper/FormWrapper';
import NameHeader from 'components/nameHeader/NameHeader';
import ProgressBar from 'components/Progress/ProgressBar';
import InfoBar from 'components/InfoBar/InfoBar';
import { useAppSelector } from 'hooks/useRedux';
import { workflowSelectors } from 'state/workflow';
import { useLocation } from 'react-router-dom';
import Loader from 'components/Loader/Loader';
import { DO_NOT_WORRY } from 'constants/validationMessages';
import { authSelectors } from 'state/auth';
import { ConfigurableHyperLinkSelector } from 'state/hyperlink/hyperlink.selectors';
import PersonalAssistant from 'components/PersonalAssistant/PersonalAssistant';
import { Col, Container } from 'react-bootstrap';
import HighlightSection from 'components/HightlightSection/HighlightSection';

const EPCSEnrollment = () => {
  const user = useAppSelector(authSelectors.userSelector);
  const hyperlinks = useAppSelector(ConfigurableHyperLinkSelector);

  const isLoading = useAppSelector(workflowSelectors.loadingSelector);

  const stepSelector = 2;

  const location = useLocation();

  const identifier = location.state?.identifier;

  if (!identifier) {
    return null;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <PersonalAssistant />
      <NameHeader
        serviceType={false}
        signOut
      />
      <HighlightSection>
        <ProgressBar
          steps={[
            { id: 0, label: 'Initial Onboarding' },
            { id: 1, label: 'Identity Proofing' },
            { id: 2, label: 'EPCS Registration' },
            { id: 3, label: 'Logical Access Control (LAC)' },
          ]}
          activeStep={stepSelector}
        />
      </HighlightSection>
      <Container>
        <FormWrapper
          text={`Step ${stepSelector + 1} of 4: EPCS Registration`}
          errorSubTitle={DO_NOT_WORRY}
        >
          <Col
            xs={12}
            className="text-start pb-3"
          >
            <Container className="bg-light-gray border p-3">
              {user && <h5 className="m-0 fw-bold">{`Hello Dr. ${user.name}`}</h5>}
            </Container>
            <p className="mt-3 mb-0">
              Set up your two-factor authentication (2FA) credentials and establish a passphrase.
              This passphrase will be required for authorizing controlled substance prescriptions.
            </p>
            <p className="mt-3 mb-0">
              After receiving the verification code, continue the process by using the link found in
              the original IDP success email from InfinID.
            </p>
          </Col>
          <InfoBar border>
            If it has been more than 7 business days since you completed the Identity Proofing and
            have not received your IDP verification code,{' '}
            <a
              id="chat-with-us-anchor-EPCS-enrollment"
              href={hyperlinks['support_chat_url']}
              target="_blank"
              className="text-purple"
            >
              chat with us
            </a>{' '}
            or contact support at (855) 863-1355. Please have your NPI and email address ready.{' '}
          </InfoBar>
        </FormWrapper>
      </Container>
    </>
  );
};

export default EPCSEnrollment;
